export default __webpack_public_path__ + "static/media/prod3.64c323bc.jpg";